<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">コース登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'course' }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_course.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmAdded)" ref="form">
          <table class="table table-form">
            <tbody>
              <ChoiceField
                v-model="corporationChoiceFieldMultiModels"
                extraRules="required_select"
                label="法人名（法人ID）"
                placeholder="選択してください"
                resourceType="corporation"
                modelFieldName="corporation"
                :choiceDisable="loggedInAsCorporation || loggedInAsBrand"
                :childFieldNames="['brand']"
                :formData="currentCourse"
              />
              <ChoiceField
                v-model="brandChoiceFieldMultiModels"
                extraRules="required_select"
                label="ブランド名（ブランドID）"
                placeholder="選択してください"
                resourceType="brand"
                modelFieldName="brand"
                :choiceDisable="loggedInAsBrand || isEmpty(currentCourse.corporation)"
                :formData="currentCourse"
              />
              <TextField
                v-model="currentCourse.name"
                extraRules="required"
                label="コース名"
                placeholder="入力してください"
              />
              <TextField
                v-model="currentCourse.nameReading"
                extraRules="required"
                label="コース名フリガナ"
                placeholder="入力してください"
              />
              <SelectField
                label="確認テスト合格点数"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="testPassingScoreOptions"
                v-model="currentCourse.testPassingScore"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import EventBus from '@/helpers/EventBus.js';
import TextField from '@/components/forms/TextField.vue';
import SelectField from '@/components/forms/SelectField.vue';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';

export default {
  data() {
    return {
      password: '',
      verifyPassword: '',
      currentCourse: {},
    };
  },
  components: {
    ValidationObserver,
    TextField,
    SelectField,
    ChoiceField,
  },
  computed: {
    corporationChoiceFieldMultiModels() {
      return basicCorporationNameIdPresent(this.currentCourse.corporation);
    },
    brandChoiceFieldMultiModels() {
      return basicBrandNameIdPresent(this.currentCourse.brand);
    },
    ...mapState(['course']),
    ...mapState('form', ['prevFormData']),
    ...mapState(['corporation']),
    ...mapState(['brand']),
    ...mapGetters('auth', ['loggedInAsCorporation', 'loggedInAsBrand']),
    ...mapGetters('course', ['testPassingScoreOptions']),
  },
  mounted() {
    EventBus.$on('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  created() {
    this.currentCourse = this.createFreshCourseObject();
  },
  beforeDestroy() {
    EventBus.$off('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  methods: {
    createFreshCourseObject() {
      if (this.course.editingCourse) {
        this.$logger.debug('Editing old Course with ID ' + this.course.editingCourse);
        return this.course.editingCourse;
      } else if (this.prevFormData) {
        this.$logger.debug('Restoring previous form data', this.prevFormData);
        return this.prevFormData;
      } else {
        let newCourse = {
          corporation: null,
          brand: null,
          name: '',
          nameReading: '',
          testPassingScore: null,
        };
        if (this.loggedInAsCorporation) {
          newCourse['corporation'] = this.corporation.corporation;
        }
        if (this.loggedInAsBrand) {
          newCourse['brand'] = this.brand.brand;
          newCourse['corporation'] = this.brand.brand.corporation;
        }
        return newCourse;
      }
    },
    confirmAdded() {
      this.$logger.debug('Started Adding: ' + JSON.stringify(this.currentCourse));
      this.startEditingCourse(this.currentCourse);
      this.$router.push({ name: 'course-confirm' });
    },
    setCurrentRoleHandler(payload) {
      if (this.loggedInAsCorporation) {
        this.currentCourse.corporation = payload.data;
      }

      if (this.loggedInAsBrand) {
        this.currentCourse.brand = payload.data;
        this.currentCourse.corporation = payload.data.corporation;
      }

      if (this.loggedInAsSchool) {
        this.currentCourse.school = payload.data;
        this.currentCourse.brand = payload.data.brand;
        this.currentCourse.corporation = payload.data.corporation;
      }
    },
    ...mapActions('course', ['startEditingCourse']),
  },
};
</script>
<style scoped>
.btn-confirm {
  margin-left: 0px;
}
.img-inline {
  margin-left: 5px;
}
.line-break {
  width: 100%;
}
.body-td-explain {
  margin-left: 5px;
  font-size: 10px;
}
</style>
